module.exports = __webpack_public_path__ + "img/success.d725a5d2.png";